/**
 * SCORE Test based on
 * https://www.escardio.org/static_file/Escardio/Subspecialty/EACPR/Documents/risk-assessment-score-card.pdf
 *
 * @author Mario Sassmann <mario.sassmann@speedy-space.com>
 * @date 2018-12-10
 * @date 2019-06-21 removed jquery dependency
 */

( function () {

    /*
     * Get the cholesterol value used for matrix.
     */
    function getCholesterol( cholesterol ) {
        if ( cholesterol <= 150 ) {
            return 4;
        } else if ( cholesterol > 150 && cholesterol <= 200 ) {
            return 5;
        } else if ( cholesterol > 200 && cholesterol <= 250 ) {
            return 6;
        } else if ( cholesterol > 250 && cholesterol <= 300 ) {
            return 7;
        } else if ( cholesterol > 300 ) {
            return 8;
        }
    }

    /**
     * Get the blood pressure value used for matrix.
     *
     * @param blood_pressure input value.
     * @return {number}
     */
    function getBP( blood_pressure ) {
        if ( blood_pressure >= 180 ) {
            return 180;
        } else if ( blood_pressure < 180 && blood_pressure >= 170 ) {
            return 180;
        } else if ( blood_pressure < 170 && blood_pressure >= 150 ) {
            return 160;
        } else if ( blood_pressure < 150 && blood_pressure >= 130 ) {
            return 140;
        } else if ( blood_pressure < 130 && blood_pressure >= 120 ) {
            return 120;
        } else if ( blood_pressure < 120 ) {
            return 120;
        }
    }

    /**
     * Get age for matrix.
     *
     * @param age input value
     * @returns {number}
     */
    function getAge( age ) {
        if ( age < 45 ) {
            return 40;
        } else if ( age >= 45 && age <= 52 ) {
            return 50;
        } else if ( age >= 52 && age <= 57 ) {
            return 55;
        } else if ( age >= 57 && age <= 62 ) {
            return 60;
        } else if ( age > 62 ) {
            return 65;
        }
    }


// women

// non-smoker
    const women_non_smoker_age_40 = [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
    ];

    const women_non_smoker_age_50 = [
        [1, 1, 1, 1, 1],
        [0, 0, 1, 1, 1],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
    ];

    const women_non_smoker_age_55 = [
        [1, 1, 2, 2, 2],
        [1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1],
        [0, 0, 1, 1, 1]
    ];

    const women_non_smoker_age_60 = [
        [3, 3, 3, 4, 4],
        [2, 2, 2, 2, 3],
        [1, 1, 1, 2, 2],
        [1, 1, 1, 1, 1]
    ];

    const women_non_smoker_age_65 = [
        [4, 5, 6, 6, 7],
        [3, 3, 4, 4, 5],
        [2, 2, 2, 3, 3],
        [1, 1, 2, 2, 2]
    ];

// smoker
    const women_smoker_age_40 = [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
    ];

    const women_smoker_age_50 = [
        [1, 1, 2, 2, 2],
        [1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1],
        [0, 0, 0, 1, 1]
    ];

    const women_smoker_age_55 = [
        [3, 3, 3, 4, 4],
        [2, 2, 2, 3, 3],
        [1, 1, 1, 2, 2],
        [1, 1, 1, 1, 1]
    ];

    const women_smoker_age_60 = [
        [5, 5, 6, 7, 8],
        [3, 4, 4, 5, 9],
        [2, 2, 3, 3, 4],
        [1, 2, 2, 2, 3]
    ];

    const women_smoker_age_65 = [
        [9, 9, 11, 12, 14],
        [6, 6, 7, 8, 10],
        [4, 4, 5, 6, 7],
        [3, 3, 3, 4, 4]
    ];

// men
// non-smoker
    const men_non_smoker_age_40 = [
        [0, 1, 1, 1, 1],
        [0, 0, 0, 1, 1],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
    ];

    const men_non_smoker_age_50 = [
        [2, 2, 3, 3, 4],
        [1, 1, 2, 2, 2],
        [1, 1, 1, 1, 2],
        [1, 1, 1, 1, 1]
    ];

    const men_non_smoker_age_55 = [
        [3, 4, 4, 5, 6],
        [2, 2, 3, 3, 4],
        [1, 2, 2, 2, 3],
        [1, 1, 1, 2, 2]
    ];

    const men_non_smoker_age_60 = [
        [5, 6, 7, 8, 9],
        [3, 4, 5, 5, 6],
        [2, 3, 3, 4, 4],
        [2, 2, 2, 3, 3]
    ];

    const men_non_smoker_age_65 = [
        [8, 9, 10, 12, 14],
        [5, 6, 7, 8, 10],
        [4, 4, 5, 6, 7],
        [2, 3, 3, 4, 5]
    ];

// smoker
    const men_smoker_age_40 = [
        [1, 1, 1, 2, 2],
        [1, 1, 1, 1, 1],
        [0, 1, 1, 1, 1],
        [0, 0, 0, 1, 1]
    ];

    const men_smoker_age_50 = [
        [4, 4, 5, 6, 7],
        [2, 3, 3, 4, 5],
        [2, 2, 2, 3, 3],
        [1, 1, 2, 2, 2]
    ];

    const men_smoker_age_55 = [
        [6, 7, 8, 10, 12],
        [4, 5, 6, 7, 8],
        [3, 3, 4, 5, 6],
        [2, 2, 3, 3, 4]
    ];

    const men_smoker_age_60 = [
        [10, 11, 13, 15, 18],
        [7, 8, 9, 11, 13],
        [5, 5, 6, 7, 9],
        [3, 4, 4, 5, 6]
    ];

    const men_smoker_age_65 = [
        [15, 17, 20, 23, 26],
        [10, 12, 14, 16, 19],
        [7, 8, 9, 11, 13],
        [5, 5, 6, 8, 9]
    ];

    /**
     * Return the used matrix.
     *
     * @param sex
     * @param is_smoker
     * @param final_age
     * @returns {number[][]}
     */
    function getMatrix( sex, is_smoker, final_age ) {
        if ( sex === 'f' && ! is_smoker ) {
            switch ( final_age ) {
                case 40:
                    return women_non_smoker_age_40;
                case 50:
                    return women_non_smoker_age_50;
                case 55:
                    return women_non_smoker_age_55;
                case 60:
                    return women_non_smoker_age_60;
                case 65:
                    return women_non_smoker_age_65;
            }
        }

        if ( sex === 'f' && is_smoker ) {
            switch ( final_age ) {
                case 40:
                    return women_smoker_age_40;
                case 50:
                    return women_smoker_age_50;
                case 55:
                    return women_smoker_age_55;
                case 60:
                    return women_smoker_age_60;
                case 65:
                    return women_smoker_age_65;
            }
        }

        if ( sex === 'm' && ! is_smoker ) {
            switch ( final_age ) {
                case 40:
                    return men_non_smoker_age_40;
                case 50:
                    return men_non_smoker_age_50;
                case 55:
                    return men_non_smoker_age_55;
                case 60:
                    return men_non_smoker_age_60;
                case 65:
                    return men_non_smoker_age_65;
            }
        }

        if ( sex === 'm' && is_smoker ) {
            switch ( final_age ) {
                case 40:
                    return men_smoker_age_40;
                case 50:
                    return men_smoker_age_50;
                case 55:
                    return men_smoker_age_55;
                case 60:
                    return men_smoker_age_60;
                case 65:
                    return men_smoker_age_65;
            }
        }
    }

    const blood_pressure_index_map = {
        '180' : 0,
        '160' : 1,
        '140' : 2,
        '120' : 3
    };

    const cholesterol_index_map = {
        '4' : 0,
        '5' : 1,
        '6' : 2,
        '7' : 3,
        '8' : 4
    };

    /**
     * Calculate the final score.
     *
     * @param sex
     * @param is_smoker bool
     * @param age
     * @param blood_pressure
     * @param cholesterol
     *
     * @returns {number} the score.
     */
    function getScore( sex, is_smoker, age, blood_pressure, cholesterol ) {
        const neared_age = getAge( age );
        const bp_key = getBP( blood_pressure );
        const chol_key = getCholesterol( cholesterol );
        const used_matrix = getMatrix( sex, is_smoker, neared_age );

        return used_matrix[ blood_pressure_index_map[ bp_key ] ][ cholesterol_index_map[ chol_key ] ];
    }

    /**
     * Get the score class and text according to result.
     *
     * @param score
     * @returns {*}
     */
    function getScoreText( score ) {
        if ( score < 1 ) {
            return {
                class : 'low-risk',
                text : '<strong>niedrig</strong> (< 1%)'
            };
        } else if ( score >= 1 && score < 5 ) {
            return {
                class : 'moderate-risk',
                text : '<strong>mittelgradig</strong> (1 - < 5%)'
            };
        } else if ( score >= 5 && score < 10 ) {
            return {
                class : 'high-risk',
                text : '<strong>hoch</strong> (5 - < 10%)'
            };
        } else {
            return {
                class : 'very-high-risk',
                text : '<strong>sehr hoch</strong> (≥ 10%)'
            };
        }
    }

    /**
     * Validation messages.
     * @type {{chol: string, age: string, bp: string}}
     */
    const score_form_validation_messages = {
        'age' : 'Bitte geben Sie ein Alter ab 40 Jahren ein.',
        'bp' : 'Bitte geben Sie einen Blutdruck von mindestens 90 mmHg an.',
        'chol' : 'Bitte geben Sie einen Cholesterin-Wert zwischen 100 und 500 mg/dl an.'
    };
    const age_sel = document.getElementById( 'frm-age' );
    const blood_pressure_sel = document.getElementById( 'frm-bp' );
    const cholesterol_sel = document.getElementById( 'frm-chol' );

    document.getElementById( 'frm-button-calc' ).addEventListener( 'click', () => {
        const form_selector = document.getElementById( 'frm-score-tool' );
        const result_container_selector = document.getElementById( 'score-result-container' );
        const fake_submit_button = document.getElementById( 'frm-submit' );

        if ( ! form_selector.checkValidity() ) {
            // simulate click on submit button, otherwise validation message don't appear
            fake_submit_button.click();
            return false;
        }

        const age = age_sel.value;
        const sex = form_selector.querySelector( 'input[name=frm-sex]:checked' ).value;
        const is_smoker = form_selector.querySelector( 'input[name=frm-is-smoker]:checked' ).value;
        const blood_pressure = blood_pressure_sel.value;
        const cholesterol = cholesterol_sel.value;

        const score = getScore( sex, parseInt( is_smoker ), age, blood_pressure, cholesterol );
        const score_text = getScoreText( score );

        result_container_selector.querySelector( '.score-number-box' ).innerHTML = score + '%';
        result_container_selector.querySelector( '.score-result-text' )
            .querySelector( '.score-number' ).innerHTML = score + '%';
        result_container_selector.querySelector( '.score-result-text' )
            .querySelector( '.score-result-classification' ).innerHTML = score_text.text;
        result_container_selector.removeAttribute( 'class' );
        result_container_selector.classList.add( score_text.class );
        result_container_selector.style.display = 'block';

    } );

// don't show validation messages on input.
    const score_tool = document.getElementById( 'frm-score-tool' );
    const input_fields = score_tool.querySelectorAll( 'input' );

    for ( let f of input_fields ) {
        f.addEventListener( 'input', function () {
            this.setCustomValidity( '' );
        } );
    }

    age_sel.addEventListener( 'invalid', function () {
        this.setCustomValidity( score_form_validation_messages['age'] );
    } );

    blood_pressure_sel.addEventListener( 'invalid', function () {
        this.setCustomValidity( score_form_validation_messages['bp'] );
    } );

    cholesterol_sel.addEventListener( 'invalid', function () {
        this.setCustomValidity( score_form_validation_messages['chol'] );
    } );

}) ();


